"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionServiceReadyEvent = void 0;
const event_types_1 = require("../enums/event-types");
class SessionServiceReadyEvent {
    constructor(sessionService) {
        this.eventType = SessionServiceReadyEvent.EventType;
        this.timestamp = new Date();
        this.sessionService = sessionService;
    }
}
exports.SessionServiceReadyEvent = SessionServiceReadyEvent;
SessionServiceReadyEvent.EventType = event_types_1.SessionServiceEventType.SESSION_SERVICE_READY;
